// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"54b14746","488":"42ea1fd6","796":"2fc8bb05"}[chunkId] + ".chunk.js";
};